<template>
    <div class="contest-container">
        <div class="banner">
            <div class="swiper-container">
                <swiper :options="swiperOptions" ref="mySwiper" v-if="banner_list.length">
                    <!-- Slides -->
                    <swiper-slide v-for="(item,index) in banner_list" :key="index" @click="onSwiperClick(item)">
                        <img :src="item.image" class="swiper-img" />
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
        </div>
        <div class="contest-list">
            <div class="title-under-banner">—— Hot Contests ——</div>
            <div class="contest-item" v-for="(item,index) in list" :key="index" @click="$router.push({name:'ContestDetail',params:{uuid:item.uuid}})">
                <img :src="item.cover|default_img" />
                <div class="contest-desc">
                    <div class="title">{{item.title}}</div>
                    <div class="time-range">{{item.start_time}} - {{item.end_time}}</div>
                    <div class="status">
                        <div class="status-label" :class="[item.status_label]" v-if="item.status == 2">
                            {{item.match_time | countDay}}
                        </div>
                        <div class="status-label" :class="[item.status_label]" v-else-if="item.status == 1">
                            {{item.sign_time | countSign}}
                        </div>
                        <div class="status-label" :class="[item.status_label]" v-else-if="item.status == 0">
                            Coming Soon
                        </div>
                        <div class="status-label" :class="[item.status_label]" v-else-if="item.status == 3">
                            Under Review
                        </div>
                        <div class="status-label" :class="[item.status_label]" v-else>
                            Ended
                        </div>
                        <div class="views">
                            <img src="../../assets/images/icon-view-popup.png" />
                            {{item.view_times || 0}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-container">
                <Page :total="total_count" prev-text="上一页" next-text="下一页" @on-change="onPageChange"></Page>
            </div>
        </div>
        <div class="create-contest">
             <!-- <div class="create-contest-main"></div> -->
              <div class="title">Yichuang Community Design Contest</div>
              <div class="desc">It's a brand competition, and more importantly, a brand event marketing</div>
              <div class="item-list">
                <div class="item">
                    <div class="icon-box">
                        <img src="../../assets/images/icon-contest-img.png"/>
                    </div>
                    <div class="item-desc">Massive production of excellent works</div>
                </div>
                <div class="item">
                    <div class="icon-box">
                        <img src="../../assets/images/icon-contest-flow.png"/>
                    </div>
                    
                    <div class="item-desc">Tens of millions of vertical traffic aggregation</div>
                </div>
                <div class="item">
                    <div class="icon-box">
                        <img src="../../assets/images/icon-contest-transmit.png"/>
                    </div>
                    
                    <div class="item-desc">Hundreds of millions of brand exposure and dissemination</div>
                </div>
              </div>
        </div>
        <div class="community-contest">
			<div class="title-en">YICHUANG COMMUNITY</div>
			<div class="title-cn">Yichuang Community</div>
			<div class="content-box">
				<div class="item-box">
					<div class="item-num">30<span>Years</span></div>
					<div class="item-content">Deep cultivation in the garment industry</div>
				</div>
				<div class="item-box">
					<div class="item-num">1200<span>Ten Thousand</span></div>
					<div class="item-content">Annual finished garment production</div>
				</div>
				<div class="item-box">
					<div class="item-num">3500<span>Tons</span></div>
					<div class="item-content">Annual fabric production</div>
				</div>
			</div>
		</div>
		<div class="contest-about">
			<div class="about-content">
				<div class="title-en">ABOUT US</div>
				<div class="title-cn">About Us<span class="line"></span></div>
				<div class="content">
					<div class="title">The Power Behind Yichuang Community</div>
					<div class="content">
						After 33 years of deep cultivation in the garment industry, Yichuang Community has strong full garment industry chain resources and a mature "intelligent manufacturing" system behind it.
						The company has built modern standard factories and intelligent production lines, with an annual output of up to 12 million sets of finished garments and 3,500 tons of fabric, achieving high integration of multiple links from textile, embroidery to finished garments.
						It continuously improves production stability and efficiency through R&D innovation and quality control. With superior product quality, rich industry experience, and extensive domestic and international market layout, it has won many important honors in the fields of garment manufacturing and technological innovation.
						The business map covers key global regions such as Australia, the United States, New Zealand, and Cambodia, with its own brands, overseas marketing teams, and complete overseas warehousing and logistics systems.
						It maintains long-term strategic cooperation with many well-known enterprises and institutions, continuously expanding global market share and brand influence.</div>
					<div class="title">Yichuang Community - The Industry's First AI-empowered One-stop Garment Design, Production, and Sales Service Platform</div>
					<div class="content">
						It was born on this strong industrial foundation, aiming to provide garment designers with one-stop creative implementation and commercial support.
						From sample making to effective connection with flexible supply chain resources, Yichuang Community is committed to creating an open, shared, and collaborative ecosystem platform to easily transform more design inspirations into high-quality finished products.
						We hope to work with every partner who loves design and garment innovation to lead the creative transformation of the garment industry, create a broader value stage for more brands and individuals, and inject continuous vitality and value into the industry.</div>
				</div>
			</div>
			<div class="bg"></div>
		</div>
        <SideMenu></SideMenu>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import { GetMatchList } from '@/api/social'
import {
    swiper,
    swiperSlide
} from 'vue-awesome-swiper'
import {GetBannerList} from "@/api"
import SideMenu from '@/components/SideMenu/SideMenu'
export default{
    data(){
        return {
            swiperOptions: {
                // 核心配置
                slidesPerView: 1,           // 每页显示 1 张幻灯片
                centeredSlides: true,       // 当前幻灯片居中显示
                spaceBetween: 10,           // 幻灯片间距
                loop: true,                 // 启用循环模式
                loopedSlides: 0,
                grabCursor: true,           // 拖动时显示抓手光标
                autoplay: {
                    delay: 3000, // 3秒切换
                    disableOnInteraction: false // 手动滑动后继续自动播放
                },

                pagination: {
                    el: '.swiper-pagination', // 指定分页器容器选择器
                    type: 'bullets',          // 类型：bullets（圆点）、fraction（分数）、progress（进度条）等
                    clickable: true,          // 允许点击分页器切换幻灯片
                    bulletActiveClass: 'my-swiper-pagination-active', // 自定义激活状态类名
                },
            },
            banner_list:[],
            list:[],
            isBackToTopVisible: false,
            page:1,
            limit:9,
            total_count:0,
            
        }
    },
    components: {
        swiper,swiperSlide,SideMenu
    },
    filters:{
        countDay(val){
            const end_time = dayjs(val);
            const now = dayjs();
            const diffDays = end_time.diff(now, 'day');
            return diffDays >= 0 ? diffDays == 0 ? 'Less than 24 hours left until deadline' :`Only ${diffDays} days left until deadline` : 'Deadline passed';
        },
        countSign(val){
            const end_time = dayjs(val);
            const now = dayjs();
            const diffDays = end_time.diff(now, 'day');
            return diffDays >= 0 ? diffDays == 0 ? 'Less than 24 hours left until registration deadline' : `Only ${diffDays} days left until registration deadline` : 'Registration time passed';
        }
    },
    beforeRouteEnter(to, from, next) {
			next((vm) => {
			// 通过 `vm` 访问组件实例
			vm.$emit("changeFooter", 'light');
			});
		},	
    mounted(){
        window.addEventListener('scroll', this.handleScroll);
        this.onGetBannerList();
        this.onGetMatchList();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods:{
        async onGetMatchList(){
            try{
                const {page,limit} = this;
                const param = {};
                param.page = page;
                param.limit = limit;
                const {data} = await GetMatchList(param);
                this.list = data.list;
                this.total_count = data.count;
            }catch(e){
                console.log('e',e);
            }
        },
        onPageChange(e){
            console.log('page_change',e);
            this.page = e;
            this.onGetMatchList();
        },
        handleScroll() {
            this.isBackToTopVisible = window.pageYOffset > 100; // 滚动超过 300px 显示
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        async onGetBannerList(){
            try{
                const param = {};
                param.position = 5;  // TODO 这里参数要改
                const {data} = await GetBannerList(param);
                this.swiperOptions.loopedSlides = data.length;
                this.banner_list = data;
            }catch(e){
                console.log('e-banner',e);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import './contest.scss'
</style>